"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearch = setSearch;
exports.filterListingsByAll = filterListingsByAll;
exports.wait = wait;
exports.updateConnectedStatus = updateConnectedStatus;
exports.setAndFilter = setAndFilter;
exports.fetchListings = fetchListings;
exports.filterByCategory = filterByCategory;
exports.setCategory = setCategory;
exports.fetchCategoriesIfNeeded = fetchCategoriesIfNeeded;
exports.setAndFilterByCategory = setAndFilterByCategory;
exports.setCategorySlug = setCategorySlug;
exports.shouldFetchListings = shouldFetchListings;
exports.fetchListingsIfNeeded = fetchListingsIfNeeded;
exports.filterByField = filterByField;
exports.default = listings;
exports.unionByID = exports.initialState = exports.clearSearch = exports.FILTER_BY_CATEGORY = exports.SET_CATEGORY_SLUG = exports.SET_CATEGORY = exports.CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCHED = exports.FETCH_CATEGORIES = exports.UPDATE_CONNECTED_STATUS = exports.WAIT = exports.FILTER_LISTINGS_BY_ALL = exports.CLEAR_SEARCH = exports.LISTINGS_SET_SEARCH = exports.LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCHED = exports.LISTINGS_FETCHING = exports.LISTINGS_INVALID = void 0;

var _objectAssign = _interopRequireDefault(require("object-assign"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));

var _some2 = _interopRequireDefault(require("lodash/some"));

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _intersection2 = _interopRequireDefault(require("lodash/intersection"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _config = _interopRequireDefault(require("../config"));

var _utils = require("../utils");

var userProfileActions = _interopRequireWildcard(require("../userProfile/userProfileModule"));

var listingActions = _interopRequireWildcard(require("../listing/listingModule"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// Constants
var LISTINGS_INVALID = '@@listings/LISTINGS_INVALID';
exports.LISTINGS_INVALID = LISTINGS_INVALID;
var LISTINGS_FETCHING = '@@listings/LISTINGS_FETCHING';
exports.LISTINGS_FETCHING = LISTINGS_FETCHING;
var LISTINGS_FETCHED = '@@listings/LISTINGS_FETCHED';
exports.LISTINGS_FETCHED = LISTINGS_FETCHED;
var LISTINGS_FETCH_FAILED = '@@listings/LISTINGS_FETCH_FAILED';
exports.LISTINGS_FETCH_FAILED = LISTINGS_FETCH_FAILED;
var LISTINGS_SET_SEARCH = '@@listings/LISTINGS_SET_SEARCH';
exports.LISTINGS_SET_SEARCH = LISTINGS_SET_SEARCH;
var CLEAR_SEARCH = '@@listings/CLEAR_SEARCH';
exports.CLEAR_SEARCH = CLEAR_SEARCH;
var FILTER_LISTINGS_BY_ALL = '@@listings/FILTER_LISTINGS_BY_ALL';
exports.FILTER_LISTINGS_BY_ALL = FILTER_LISTINGS_BY_ALL;
var WAIT = '@@listings/WAIT';
exports.WAIT = WAIT;
var UPDATE_CONNECTED_STATUS = '@@listings/UPDATE_CONNECTED_STATUS';
exports.UPDATE_CONNECTED_STATUS = UPDATE_CONNECTED_STATUS;
var FETCH_CATEGORIES = '@@listings/FETCH_CATEGORIES';
exports.FETCH_CATEGORIES = FETCH_CATEGORIES;
var CATEGORIES_FETCHED = '@@listings/CATEGORIES_FETCHED';
exports.CATEGORIES_FETCHED = CATEGORIES_FETCHED;
var CATEGORIES_FETCH_FAILED = '@@listings/CATEGORIES_FETCH_FAILED';
exports.CATEGORIES_FETCH_FAILED = CATEGORIES_FETCH_FAILED;
var SET_CATEGORY = '@@listings/SET_CATEGORY';
exports.SET_CATEGORY = SET_CATEGORY;
var SET_CATEGORY_SLUG = '@@listings/SET_CATEGORY_SLUG';
exports.SET_CATEGORY_SLUG = SET_CATEGORY_SLUG;
var FILTER_BY_CATEGORY = '@@listings/FILTER_BY_CATEGORY';
exports.FILTER_BY_CATEGORY = FILTER_BY_CATEGORY;
var APIEndpoint;

if ((0, _utils.canUseDOM)()) {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/api/listings");
} else {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/api/listings");
} // Actions


function setSearch(value) {
  return {
    type: LISTINGS_SET_SEARCH,
    value: value
  };
}

function filterListingsByAll() {
  return {
    type: FILTER_LISTINGS_BY_ALL
  };
} // this is only to introduce artificial delay, (don't test it)


function wait(time) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(dispatch({
          type: WAIT
        }));
      }, time);
    });
  };
}

function updateConnectedStatus(listingId, status) {
  return function (dispatch, getState) {
    var _getState$listings = getState().listings,
        list = _getState$listings.list,
        filtered = _getState$listings.filtered;

    var updateList = function updateList(listToUpdate) {
      return listToUpdate.map(function (el) {
        if (el.ID === listingId) {
          return (0, _merge2.default)({}, el, {
            isConnecting: false,
            core: {
              isUserConnected: status
            }
          });
        }

        return el;
      });
    };

    if (list.length > 0 || filtered.length > 0) {
      var newList = updateList(list);
      var newFilteredList = updateList(filtered);
      dispatch({
        type: UPDATE_CONNECTED_STATUS,
        newList: newList,
        newFilteredList: newFilteredList
      });
    }
  };
}

function setAndFilter(value) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(setSearch(value));
      resolve(dispatch(filterListingsByAll()));
    });
  };
}

function fetchListings() {
  return function asyncFetchListings(dispatch, getState) {
    var _getState, _getState$userPrefs$l, lang, userProfile, _getState$JWT, _getState$JWT$token, token, listings, meta, parameters, extraCountries, endpoint, fetchListingsCall, listingsResponse, approvedAndVisible, _getState2, _getState2$listings, categorySlug, list, search;

    return regeneratorRuntime.async(function asyncFetchListings$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchListingsCall = function _ref() {
              var options, response;
              return regeneratorRuntime.async(function fetchListingsCall$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      options = {
                        method: 'GET',
                        headers: {}
                      };
                      if (token) options.headers.Authorization = "Bearer ".concat(token);
                      _context.next = 4;
                      return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

                    case 4:
                      response = _context.sent;
                      return _context.abrupt("return", response.json());

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              });
            };

            _context2.next = 3;
            return regeneratorRuntime.awrap(dispatch(userProfileActions.fetchUserProfileIfNeeded()));

          case 3:
            dispatch({
              type: LISTINGS_FETCHING
            });
            _getState = getState(), _getState$userPrefs$l = _getState.userPrefs.localeData.lang, lang = _getState$userPrefs$l === void 0 ? 'en-us' : _getState$userPrefs$l, userProfile = _getState.userProfile, _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token, listings = _getState.listings, meta = _getState.meta;
            parameters = {
              category: (0, _get2.default)(listings, 'category.slug', ''),
              lang: lang
            }; // The Public US site should show listings for ALL countries.
            // This is an exception. Other countries should still limit the results.

            if (meta.isPublic && meta.country !== 'US' && meta.country !== 'CN') {
              parameters.country = meta.country;
            } // Request HK, TW, CN listings when in public china


            extraCountries = meta.isPublic && meta.country === 'CN' ? '&country=CN,TW,HK' : '';
            endpoint = "".concat(APIEndpoint).concat((0, _utils.buildQueryString)(parameters)).concat(extraCountries);
            _context2.prev = 11;
            _context2.next = 14;
            return regeneratorRuntime.awrap(fetchListingsCall());

          case 14:
            listingsResponse = _context2.sent;
            approvedAndVisible = listingsResponse.items.filter(function (item) {
              // in public show only if localized content is available
              var fixedLang = lang === 'en' ? 'en-us' : lang;

              if (meta.isPublic && item.localized && item.localized.lang !== fixedLang) {
                return false;
              }

              if (userProfile && userProfile.profile && userProfile.profile.betas['appmgmt-246 - hideApps']) {
                if (item.core.isVisible && item.core.approvalStatus === 'APPROVED' && !item.core.listingDisabled) {
                  if (token && item.core.clientOptInType === 'USER') {
                    return (0, _intersection2.default)(item.core.offerings, userProfile.offeringsEnabled).length > 0;
                  }

                  return true;
                }
              } else if (item.core.isVisible && item.core.approvalStatus === 'APPROVED') {
                if (token && item.core.clientOptInType === 'USER') {
                  return (0, _intersection2.default)(item.core.offerings, userProfile.offeringsEnabled).length > 0;
                }

                return true;
              }
            });
            dispatch(listingActions.setListings(approvedAndVisible));
            dispatch({
              type: LISTINGS_FETCHED,
              result: approvedAndVisible
            });
            dispatch({
              type: FILTER_LISTINGS_BY_ALL
            });
            _getState2 = getState(), _getState2$listings = _getState2.listings, categorySlug = _getState2$listings.categorySlug, list = _getState2$listings.list, search = _getState2$listings.search;

            if (categorySlug && list.length && search === '') {
              dispatch(setCategory());
            }

            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](11);
            dispatch({
              type: LISTINGS_FETCH_FAILED,
              error: _context2.t0
            });

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[11, 23]]);
  };
}

function flattenCategories(list) {
  var flattened = {};
  list.forEach(function (category) {
    flattened[category.slug] = category;

    if (category.subcategories.length > 0) {
      category.subcategories.forEach(function (subCategory) {
        return flattened[subCategory.slug] = subCategory;
      });
    }
  });
  return flattened;
}

function filterByCategory() {
  return {
    type: FILTER_BY_CATEGORY
  };
}

function setCategory(givenCatgory) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$listings$c = _getState3.listings.categories,
        categories = _getState3$listings$c === void 0 ? [] : _getState3$listings$c;

    if (givenCatgory) {
      dispatch({
        type: SET_CATEGORY,
        category: givenCatgory
      });
      dispatch(filterByCategory());
    } else if (categories.length) {
      var flatMapCategories = flattenCategories(categories);
      var theChosenOne = flatMapCategories[getState().listings.categorySlug];
      dispatch({
        type: SET_CATEGORY,
        category: theChosenOne
      });
      dispatch(filterByCategory());
    }

    if (!categories.length) {
      dispatch(fetchCategoriesIfNeeded());
    }
  };
}

function fetchCategoriesIfNeeded() {
  return function asyncFetchCategories(dispatch, getState) {
    var _getState4, categories, _getState4$userPrefs$, lang, path, categoriesAPIEndpoint, options, response, categoriesResponse;

    return regeneratorRuntime.async(function asyncFetchCategories$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState4 = getState(), categories = _getState4.listings.categories, _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;

            if (!(!categories || categories.length === 0)) {
              _context3.next = 20;
              break;
            }

            path = "api/listitems/categories?lang=".concat(lang);

            if ((0, _utils.canUseDOM)()) {
              categoriesAPIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/").concat(path);
            } else {
              categoriesAPIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/").concat(path);
            }

            dispatch({
              type: FETCH_CATEGORIES
            });
            options = {
              method: 'GET',
              headers: {}
            };
            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(categoriesAPIEndpoint, options));

          case 9:
            response = _context3.sent;
            _context3.next = 12;
            return regeneratorRuntime.awrap(response.json());

          case 12:
            categoriesResponse = _context3.sent;
            dispatch({
              type: CATEGORIES_FETCHED,
              result: categoriesResponse
            });
            return _context3.abrupt("return", categoriesResponse);

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](6);
            dispatch({
              type: CATEGORIES_FETCH_FAILED,
              error: _context3.t0
            });

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 17]]);
  };
}

function setAndFilterByCategory(value) {
  return function (dispatch) {
    dispatch(setCategory(value));
    dispatch(filterByCategory());
  };
}

function setCategorySlug(slug) {
  return {
    type: SET_CATEGORY_SLUG,
    slug: slug
  };
}

function shouldFetchListings(state, isKeywordEntered) {
  var currentListings = state.listings;

  if (currentListings.list === null || currentListings.list.length === 0 || currentListings.listingsReadyState === LISTINGS_FETCH_FAILED || currentListings.listingsReadyState === LISTINGS_INVALID || isKeywordEntered) {
    return true;
  }

  return false;
}

function fetchListingsIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchListings(getState(), getState().listings.search.length > 0)) {
      return dispatch(fetchListings());
    }
  };
}

var clearSearch = function clearSearch() {
  return {
    type: CLEAR_SEARCH
  };
}; // Reducer


exports.clearSearch = clearSearch;
var initialState = {
  listingsReadyState: LISTINGS_INVALID,
  list: [],
  search: '',
  filtered: [],
  category: undefined,
  categories: [],
  categorySlug: undefined
};
exports.initialState = initialState;

function filterByField(_ref2, field) {
  var search = _ref2.search,
      list = _ref2.list;
  return list.filter(function (listing) {
    var localized = listing.localized;

    if (!localized || !localized[field]) {
      return false;
    }

    var lowCaseSearch = search.toLowerCase();

    if (field === 'keywords') {
      var words = localized[field];
      return (0, _some2.default)(words, function (value) {
        return value.toLowerCase().includes(lowCaseSearch) || lowCaseSearch.includes(value.toLowerCase());
      });
    }

    var lowCaseField = localized[field].toLowerCase();
    return lowCaseField.includes(lowCaseSearch) || lowCaseSearch.includes(lowCaseField);
  });
}

function filterByCategoryReducer(state) {
  return state.list.filter(function (listing) {
    return listing.core.categories.includes(state.category.code);
  });
}

var unionByID = function unionByID(sets) {
  var result = (0, _uniqBy2.default)(sets, 'ID');
  return result;
};

exports.unionByID = unionByID;

function listings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LISTINGS_FETCHING:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHING
      });

    case LISTINGS_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCH_FAILED,
        error: action.error
      });

    case LISTINGS_FETCHED:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHED,
        list: action.result,
        filtered: action.result
      });

    case LISTINGS_SET_SEARCH:
      return (0, _objectAssign.default)({}, state, {
        search: action.value,
        categorySlug: 'all',
        category: {
          code: 'ALL_APPS',
          description: 'All Apps',
          parentCategory: null,
          slug: 'all'
        }
      });

    case CLEAR_SEARCH:
      return (0, _objectAssign.default)({}, state, {
        search: ''
      });

    case UPDATE_CONNECTED_STATUS:
      return (0, _merge2.default)({}, state, {
        list: action.newList,
        filtered: action.newFilteredList
      });

    case FILTER_LISTINGS_BY_ALL:
      {
        var flattened = [].concat(_toConsumableArray(filterByField(state, 'title')), _toConsumableArray(filterByField(state, 'publisher')), _toConsumableArray(filterByField(state, 'keywords')), _toConsumableArray(filterByField(state, 'name')));
        return (0, _objectAssign.default)({}, state, {
          filtered: state.search === '' ? state.list : unionByID(flattened)
        });
      }

    case FILTER_BY_CATEGORY:
      return (0, _objectAssign.default)({}, state, {
        filtered: state.category && state.category.slug !== 'all' ? filterByCategoryReducer(state) : state.list
      });

    case FETCH_CATEGORIES:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: FETCH_CATEGORIES
      });

    case CATEGORIES_FETCHED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCHED,
        categories: action.result
      });

    case CATEGORIES_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCH_FAILED,
        error: action.error
      });

    case SET_CATEGORY:
      return (0, _objectAssign.default)({}, state, {
        category: action.category,
        search: ''
      });

    case SET_CATEGORY_SLUG:
      return (0, _objectAssign.default)({}, state, {
        categorySlug: action.slug
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/listings/listingsModule.js
// module id = 10
// module chunks = 0